/**
 * GENERATED by scripts/gen-version.mjs — do not edit by hand.
 * Refresh with `npm run version:sync` from a checkout that has git.
 */
export const APP_VERSION = '3.27.318';
export const GIT_SHA = '68f4892';
